/* eslint-disable no-restricted-syntax -- Translations are not needed here, since the block editor will use the nameI18n keys, and fallback to the name keys. */
import { DesignProp, GeneralProp } from "../PropCategories";

export const textTransform = {
  prop: "style-attribute",
  name: "Text Transform",
  nameI18n: "builder_ui.prop_type.styles.text_transform",
  category: [DesignProp, GeneralProp],
  type: "select",
  defaultValue: "none",
  options: [
    {
      label: "None",
      labelI18n: "builder_ui.prop_type.styles.text_transform_types.none",
      value: "none",
    },
    {
      label: "Uppercase",
      labelI18n: "builder_ui.prop_type.styles.text_transform_types.uppercase",
      value: "uppercase",
    },
    {
      label: "Lowercase",
      labelI18n: "builder_ui.prop_type.styles.text_transform_types.lowercase",
      value: "lowercase",
    },
    {
      label: "Capitalize",
      labelI18n: "builder_ui.prop_type.styles.text_transform_types.capitalize",
      value: "capitalize",
    },
  ],
} as const;
